export default "__VITE_ASSET__ff444431__"